import Vue from "vue"
import VuePhoneNumberInput from "vue-phone-number-input"
import "vue-phone-number-input/dist/vue-phone-number-input.css"

Vue.component("vue-phone-number-input", VuePhoneNumberInput)
